import merge from 'lodash/merge'
import { isJustGiving } from '../../lib/environment'
import { deserializeUser, fetchCurrentUser } from 'supporticon/api/me'
import { fetchPage, deserializePage } from 'supporticon/api/pages'

// Constants
const c = {
  FETCH: 'app/session/FETCH',
  USER_SUCCESS: 'app/session/USER_SUCCESS',
  PAGE_SUCCESS: 'app/session/PAGE_SUCCESS',
  TEAM_SUCCESS: 'app/session/TEAM_SUCCESS',
  FAILURE: 'app/session/FAILURE',
  CLEAR: 'app/session/CLEAR'
}

// Selectors
export * from './selectors'

// Actions
export const fetchSessionUser = (params) => (dispatch) => {
  dispatch({ type: c.FETCH })

  return fetchCurrentUser(params)
    .then((result) => {
      const data = merge(result, { token: params.token })

      dispatch({
        type: c.USER_SUCCESS,
        payload: { data }
      })

      return Promise.resolve(data)
    })
    .catch((error) => {
      dispatch({
        type: c.FAILURE,
        payload: { error }
      })

      return Promise.reject(error)
    })
}

export const fetchSessionPage = (response) => (dispatch) =>
  Promise.resolve()
    .then(() => isJustGiving() ? fetchPage(response.pageId) : response)
    .then(data => {
      dispatch({
        type: c.PAGE_SUCCESS,
        payload: { data }
      })

      return data
    })

export const fetchSessionTeam = (data) => (dispatch) => {
  dispatch({
    type: c.TEAM_SUCCESS,
    payload: { data }
  })

  return Promise.resolve(data)
}

export const clearSession = () => (dispatch) => (
  dispatch({ type: c.CLEAR })
)

// Reducer
export default (state = {}, { type, payload }) => {
  switch (type) {
    case c.FETCH:
      return {
        ...state,
        status: 'fetching'
      }
    case c.USER_SUCCESS:
      return {
        ...state,
        status: 'fetched',
        user: merge(deserializeUser(payload.data), { token: payload.data.token })
      }
    case c.PAGE_SUCCESS:
      return {
        ...state,
        status: 'fetched',
        page: deserializePage(payload.data)
      }
    case c.TEAM_SUCCESS:
      return {
        ...state,
        status: 'fetched',
        team: deserializePage(payload.data)
      }
    case c.FAILURE:
      return {
        ...state,
        status: 'failed'
      }
    case c.CLEAR:
      return {
        status: 'empty'
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./store/session/index.js